import { WnInputComponent } from './wn-input/wn-input.component';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

import { SharedRoutingModule } from './shared-routing.module';
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { SpinnerComponent } from './spinner/spinner.component';
import { SharedService } from './services/shared.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
  declarations: [WnInputComponent, SpinnerComponent],
  exports: [WnInputComponent, SpinnerComponent],
  imports: [
    CommonModule,
    SharedRoutingModule,
    MatDialogModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [
  { provide: ToastrService }, SharedService]
})
export class SharedModule { }
